<template>
  <div class="xiaotaomama-information-wrapper" @touchmove.prevent.stop>
    <div
      class="main-wrapper"
      v-if="isMessage !== null">
      <van-nav-bar
        title="小淘妈妈信息登记"
      />
      <van-address-edit
        :area-list="areaList"
        show-postal
        :area-columns-placeholder="['请选择', '请选择', '请选择']"
        @save="onSave"
        v-if="isMessage"
      />
      <van-address-list
        :list="list"
        :switchable="false"
        v-else
      />
    </div>
  </div>
</template>

<script>
import areaList from '@/utils/area-list'
import { showMessage, showMessageDialog, goGet, goPost } from '@/utils/public'
export default {
  data() {
    return {
      areaList,
      isMessage: null,
      addressInfo: {},
      list: []
    }
  },
  methods: {
    onSave(content) {
      let ajaxData = {
        user_id: this.user_id,
        username: content.name,
        phone: content.tel,
        province: content.province,
        city: content.city,
        region: content.county || content.country,
        detail_addr: content.addressDetail,
        postcode: content.postalCode
      }
      goPost(
        process.env.VUE_APP_MALL_API + '/mall/v2/wechat/insert_address',
        ajaxData
      ).then(res => {
        if(res.code === 200 && res.data.insert === 1) {
          showMessage('提交地址成功', 'success')
          this.getUserInfo()
        } else {
          showMessageDialog({mesg: '保存失败,请稍后再试,或联系客服'})
        }
      })
    },
    getUserId(value) {
      // 获取参数中的UserID
      let query = value || this.$route.query
      if(query.user_id) {
        this.user_id = query.user_id
        this.getUserInfo()
      } else {
        showMessageDialog({mesg: '没找到对应的用户信息,请联系客服'})
      }
    },
    getUserInfo() {
      // 获取用户信息
      goGet(
        process.env.VUE_APP_MALL_API + '/mall/v2/wechat/address_info',
        {user_id: this.user_id}
      ).then(res => {
        if(res.code === 200) {
          let result = res.data.data
          if(result) {
            this.isMessage = false
            this.list[0] = {
              id: result.id,
              name: result.username,
              tel: result.phone,
              address: result.province + result.city + result.region + result.detail_addr
            }
          } else {
            this.isMessage = true
          }
        } else {
          showMessageDialog({mesg: '没找到对应的用户信息,请联系客服'})
        }
      })
    }
  },
  mounted() {
    this.getUserId()
  },
  beforeRouteUpdate(from) {
    this.getUserId(from.query)
  }
}
</script>

<style lang="scss" scoped>
.xiaotaomama-information-wrapper {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  .van-address-list__bottom, .van-address-item__edit {
    display: none;
  }
  .van-address-item__value {
    padding: 0;
  }
}
</style>
